const getNormalizedQuantity = logError => ({ QuantityInProductGroup, ProductName }) => quantity => {
  const t1 = typeof QuantityInProductGroup
  if (t1 !== 'number') logError('QuantityInProductGroup is not a number but ', t1)
  const t2 = typeof quantity
  if (t2 !== 'number') logError('quantity is not a number but ', t2)
  const isValid = quantity % QuantityInProductGroup === 0
  if (!isValid)
    logError(
      `Quantity (${quantity}) is not a multiple of QuantityInProductGroup (${QuantityInProductGroup}) for ${ProductName}`,
    )
  const normalized = quantity / QuantityInProductGroup
  return isValid ? normalized : quantity
}

export default getNormalizedQuantity
